// frontend/src/analytics/initGA.js
export function initGA(measurementId) {
  if (!measurementId || typeof window === "undefined") return;

  // Define gtag early so calls get queued even if the script isn't loaded yet
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // SPA will send page_view manually -> avoid double-count
  window.gtag('config', measurementId, { send_page_view: false });

  // Inject the GA script
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(s);
}
